<template>
  <div class="sw-button">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Button Title",
    },
  },
};
</script>

<style scoped>
.sw-button {
  padding: 15 20px;
  border: 1px solid black;
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/Button.vue